import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

/**
 * BreadCrumb component for page navigation hierarchy.
 * @param {Object} props
 * @param {Array<{ label: string; href?: string }>} props.items - Breadcrumb items. Last item typically has no href (current page).
 */
const BreadCrumb = ({ items = [], className = "" }) => {
  if (!items?.length) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center gap-1 text-sm ${className}`}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <ChevronRightIcon className="h-4 w-4 text-gray-400 shrink-0" />
            )}
            {item.href && !isLast ? (
              <Link
                to={item.href}
                className="text-gray-500 text-[12px] hover:text-primary transition-colors font-medium"
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={
                  isLast
                    ? "text-gray-900 text-[12px] font-semibold"
                    : "text-gray-500 text-[12px] font-medium"
                }
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default BreadCrumb;
